import React from 'react';
import { Error } from 'assets/svgs';
import BaseButton from 'components/Buttons/BaseButton';
import Container from 'components/Container/Container';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import { BackToHomeBtn, PageIcon, PageTitle, PageWrapper, SubTitle } from './styles';

const PageNotFound = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <PageWrapper>
        <PageIcon>
          <Error />
        </PageIcon>
        <PageTitle data-testid="title-404">{t('titlePageNotFound')}</PageTitle>
        <SubTitle>{t('txtPageNotFound')}</SubTitle>
        <Link href="/" passHref>
          <a>
            <BackToHomeBtn>
              <BaseButton value={t('btnBackToHome')} />
            </BackToHomeBtn>
          </a>
        </Link>
      </PageWrapper>
    </Container>
  );
};

export default PageNotFound;
